iScreenWizard.controller('GroepsprofieloptieSelectorController', function ($scope, $state, $mdDialog, Ajax, ErrorHandler, Dictionary, userService, Opleidingsgroep, Groepsprofieloptie, Competentieprofiel, nieuwGroepsprofielService) {

    $scope.userService = userService;
    $scope.nieuwGroepsprofielService = nieuwGroepsprofielService;
    $scope.groepsprofielopties = [];
    $scope.competentieprofielen = [];
    $scope.opleidingsgroepen = [];

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        nieuwGroepsprofielService.model = {};
        Opleidingsgroep.all().then(function (opleidingsgroepen) {
            $scope.opleidingsgroepen = opleidingsgroepen;
        });
        Groepsprofieloptie.all().then(function (groepsprofielopties) {
            $scope.groepsprofielopties = groepsprofielopties;
        });
    };

    $scope.loadCompetentieprofielen = function() {
        $scope.competentieprofielen = [];
        if ($scope.nieuwGroepsprofielService.model.opleidingsgroep) {
            Competentieprofiel.all({opleidingsgroep_id: $scope.nieuwGroepsprofielService.model.opleidingsgroep.id}).then(function (competentieprofielen) {
                $scope.competentieprofielen = competentieprofielen;
            });
        }
    };

    $scope.selecteerGroepsprofieloptie = function() {
        if (!nieuwGroepsprofielService.model.groepsprofieloptie) {
            alert(Dictionary.translate('app.select_group_profile_type', true));
        } else if (nieuwGroepsprofielService.model.groepsprofieloptie.key == 3 && !nieuwGroepsprofielService.model.competentieprofiel) {
            alert(Dictionary.translate('app.select_competence_profile', true));
        } else {
            nieuwGroepsprofielService.SaveState();
            $state.go('groepsprofiel/selecteer-testafnames');
        }
    };

});